import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ChangeNote, UpdateType } from '../../_models/change-note.model';
import { ChangeNoteService } from '../../_services/change-note.service';

@Component({
  selector: 'app-change-notes-modal',
  templateUrl: './change-notes-modal.component.html',
  styleUrls: ['./change-notes-modal.component.scss'],
})
export class ChangeNotesModalComponent implements OnInit {
  @Input() version: string;

  currentNote: ChangeNote | null = null;
  loading: boolean = false;
  error: boolean = false;

  constructor(
    public activeModal: NgbActiveModal,
    private changeNoteService: ChangeNoteService
  ) {}

  ngOnInit(): void {
    this.loadNoteByVersion();
  }

  private loadNoteByVersion(): void {
    if (!this.version) {
      this.currentNote = null;
      return;
    }

    this.loading = true;
    this.error = false;

    this.changeNoteService.getByVersion(this.version).subscribe({
      next: (note) => {
        this.currentNote = note;
        this.loading = false;
      },
      error: (err) => {
        console.error('Erro ao buscar change note:', err);
        this.currentNote = null;
        this.loading = false;
        // Se for 404, não é erro - apenas não existe nota para essa versão
        if (err.status !== 404) {
          this.error = true;
        }
      }
    });
  }

  close(): void {
    this.activeModal.close();
  }

  getUpdateTypeBadgeClass(updateType: UpdateType | undefined): string {
    switch (updateType) {
      case 'FEATURE':
        return 'badge-success';
      case 'BUG':
        return 'badge-danger';
      case 'MASTER':
        return 'badge-primary';
      default:
        return 'badge-secondary';
    }
  }

  getUpdateTypeLabel(updateType: UpdateType | undefined): string {
    switch (updateType) {
      case 'FEATURE':
        return 'Nova Funcionalidade';
      case 'BUG':
        return 'Correção';
      case 'MASTER':
        return 'Release Principal';
      default:
        return 'Atualização';
    }
  }

  formatDate(date: Date | string | undefined): string {
    if (!date) return '';
    return new Date(date).toLocaleDateString('pt-BR');
  }
}
